<template>
    <div class="debug-page">
        <div style="display: flex">
            <mc-app-debug :mc_app_raw_id="data.mc_app_raw_id"></mc-app-debug>
            <app-debug :app_id="data.app_id"></app-debug>
            <driver-debug :driver_id="data.driver_id"></driver-debug>
        </div>

        <application-job-debug :app_id="data.app_id"></application-job-debug>
        <delivery-lead-debug :app_id="data.app_id"></delivery-lead-debug>

        <urlshortener-debug :app_id="data.app_id"></urlshortener-debug>
    </div>
</template>

<script>
export default {
    props: [
        'data'
    ],
    data() {
        return {
        };
    },
    methods: {
    },
    mounted() {
    }
}
</script>

<style>
    .peribox {
        border: 1px solid rgb(224, 229, 235);
        padding: 15px;
    }

    .perititle {
        display: flex;
        justify-content: space-between;
        font-size: 17px;
        margin-bottom: 5px;
    }

    .periicons i {
        font-size: 14px;
        cursor: pointer;
        color: #666;
    }
    .periicons i:hover {
        color: black;
    }

    .peritable th, .peritable td {
        font-size: 12px;
        cursor: text;
        height: 25px;
        line-height: 25px;
        padding: 0 8px;
        font-size: 12px;
        max-width: 270px;
        white-space: nowrap;
        overflow: hidden;
        border: 1px solid #bebebe;
    }
    .peritable th {
        background-color: rgb(82, 112, 171);
        color: white;
        border: 1px solid black;
        text-transform: uppercase;
    }
    .peritable tr:nth-child(even) td {
        background-color: rgb(245, 246, 247);
    }

    .debug-page {
        padding: 20px;
    }
    .debug-page h2 {
        margin-top: 20px;
    }
</style>